import { render, staticRenderFns } from "./companyProductList.vue?vue&type=template&id=c236e54e&scoped=true&"
import script from "./companyProductList.vue?vue&type=script&lang=js&"
export * from "./companyProductList.vue?vue&type=script&lang=js&"
import style0 from "./companyProductList.vue?vue&type=style&index=0&id=c236e54e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c236e54e",
  null
  
)

export default component.exports